import React from 'react';
import {AgGridColumn} from "../../components/agGridColumn";
import Grid from '../../components/grid';
import { ActionProps } from '../../components/gridAction';

// Espelha SecretsManagerListService::status()
const CORES_STATUS: Record<string, string> = {
    'Vencida': '#c45252',
    'Vence em breve': '#a87721',
    'Válida': '#3b8d60',
};

const SecretsManagerList = (props:any) => {

    const actions: Array<ActionProps> = [
        {
            route: 'secrets-manager/incluir',
            color: 'primary',
            type: 'normal',
            title: 'Incluir',

        },
        {
            route: 'secrets-manager/visualizar',
            color: 'info',
            type: 'grid',
            title: 'Visualizar',

        },
        {
            route: 'secrets-manager/alterar',
            color: 'warning',
            type: 'grid',
            title: 'Editar',
        }
    ];

    const defaultColumnDefinition = {
        resizable: true,
        flex: 1,
        filter: true,
        sortable: true
    };

    return (
        <Grid actions={actions} rota="secrets-manager/list" defaultColDef={defaultColumnDefinition}>
            <AgGridColumn
                headerName="#"
                field="id"
                maxWidth={100}
            />
            <AgGridColumn
                headerName="Cliente"
                field="clienteNome"
                minWidth={200}
            />
            <AgGridColumn
                headerName="Identificador"
                field="identificador"
                minWidth={250}
            />
            <AgGridColumn
                headerName="Expiração"
                field="dataExpiracao"
                filter={'agDateColumnFilter'}
                minWidth={150}
            />
            <AgGridColumn
                headerName="Grupos de acesso"
                field="setores"
                filter={false}
                sortable={false}
                minWidth={200}
            />
            <AgGridColumn
                headerName="Status"
                field="status"
                filter={false}
                sortable={false}
                minWidth={140}
                cellStyle={({value}: any) => ({color: CORES_STATUS[value] || 'inherit', fontWeight: 600})}
            />
        </Grid>
    );
};

export default SecretsManagerList;